import {z} from 'zod'

export enum WhatsappTemplateStatus {
  DRAFT = 'DRAFT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
}

export const WhatsappTemplateListItemSchema = z.object({
  id: z.number(),
  name: z.string().max(100),
  scope: z.string().nullish(),
  status: z.string().nullish(),
  updated_on: z.string().nullish(),
  created_by: z.string().nullish(),
  active: z.boolean().nullish(),
})

export const GetWhatsAppTemplatesRequestSchema = z.object({
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
})

const WhatsAppTemplatePaginationSchema = z.object({
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
  totalElements: z.number().optional(),
  totalPages: z.number().optional(),
})

export const GetWhatsAppTemplatesResponseSchema = z.object({
  content: z.array(WhatsappTemplateListItemSchema),
  pagination: WhatsAppTemplatePaginationSchema,
  success: z.boolean().optional(),
  errorMessage: z.string().nullish(),
})

export const CreateWhatsAppTemplateRequestSchema = z.object({
  name: z.string().max(100),
  scope: z.string(),
  status: z.string(),
  message: z.string(),
  active: z.boolean(),
})

export const CreateWhatsAppTemplateResponseSchema = z.object({
  id: z.number(),
  name: z.string().max(100),
  scope: z.string().nullish(),
  status: z.string().nullish(),
  updated_on: z.string().nullish(),
  created_by: z.string().nullish(),
  active: z.boolean().nullish(),
})

export const GetWhatsAppTemplateByIdRequestSchema = z.void()
export const GetWhatsAppTemplateByIdResponseSchema = z.object({
  id: z.number(),
  name: z.string().max(100),
  message: z.string(),
  scope: z.string().nullish(),
  status: z.string().nullish(),
  updated_on: z.string().nullish(),
  created_by: z.string().nullish(),
  active: z.boolean().nullish(),
})

export const UpdateWhatsAppTemplateStatusRequestSchema = z.object({
  active: z.boolean(),
})
export const UpdateWhatsAppTemplateStatusResponseSchema = z.object({
  id: z.number(),
  name: z.string(),
  message: z.string().nullish(),
  scope: z.string().nullish(),
  active: z.boolean(),
  status: z.string(),
  created_by: z.string().nullish(),
  updated_on: z.string().nullish(),
})

export type CreateWhatsAppTemplateRequest = z.infer<typeof CreateWhatsAppTemplateRequestSchema>
export type CreateWhatsAppTemplateResponse = z.infer<typeof CreateWhatsAppTemplateResponseSchema>

export type WhatsappTemplateListItem = z.infer<typeof WhatsappTemplateListItemSchema>
export type GetWhatsAppTemplatesRequest = z.infer<typeof GetWhatsAppTemplatesRequestSchema>
export type GetWhatsAppTemplatesResponse = z.infer<typeof GetWhatsAppTemplatesResponseSchema>
export type GetWhatsAppTemplateByIdRequest = z.infer<typeof GetWhatsAppTemplateByIdRequestSchema>
export type GetWhatsAppTemplateByIdResponse = z.infer<typeof GetWhatsAppTemplateByIdResponseSchema>
export type UpdateWhatsAppTemplateStatusRequest = z.infer<typeof UpdateWhatsAppTemplateStatusRequestSchema>
export type UpdateWhatsAppTemplateStatusResponse = z.infer<typeof UpdateWhatsAppTemplateStatusResponseSchema>
